import React from 'react';
import ReactDOM from 'react-dom/client';
import { labels } from './Components/constants/labels';
import { PositionSearchWrapper } from './Components/positionSearchWrapper/positionSearchWrapper';

const wrapper = document.getElementById('js-react-app');
const root = ReactDOM.createRoot(wrapper as HTMLElement);
const dataUrl = wrapper && wrapper.getAttribute('data-url');
const html = document.querySelector('html');
const language = html?.lang.slice(0, 2) || 'de';
window.labels = labels[language];

root.render(
	<React.StrictMode>
		<PositionSearchWrapper positionSearchURL={dataUrl} language={language} />
	</React.StrictMode>
);
